import { PermissionError } from "shelving";
import { type Entity, splitEntity } from "shelving";
import { isAdminMember } from "shared/schema";
import { useMemberItem } from "../util/data.js";
import { USER } from "../util/user.js";

/** Throw an error if the current logged in user is not the creator of the entity. */
export function CreatorAssertion({ creator }: { creator: Entity }): React.ReactElement | null {
	const [type, id] = splitEntity(creator);
	return type === "profile" ? ( //
		<ProfileOwnerAssertion uid={id} />
	) : type === "group" ? (
		<GroupAdminAssertion gid={id} />
	) : null;
}

/** Throw an error if the current logged in user is not the specified profile. */
export function ProfileOwnerAssertion({ uid }: { uid: string }): null {
	if (uid !== USER.data.uid) throw new PermissionError("Must be profile user");
	return null;
}

/** Throw an error if the current logged in user is not an admin of the specified group. */
export function GroupAdminAssertion({ gid }: { gid: string }): null {
	const status = useMemberItem(gid).value?.status || "none";
	if (!isAdminMember(status)) throw new PermissionError("Must be group admin");
	return null;
}
